import React from "react";
import PropTypes from "prop-types";
import queryString from "query-string";

import { StyledSocialLink } from "./styles";

const ShareImageToSocialMedia = ({
    children,
    creatorName,
    platform,
    imageType,
    permalinkPath
}) => {
    const getShareUrl = () => {
        const imagePermalink = `https://${location.host}${permalinkPath}`;

        let shareUrl = "";
        let shareUrlQueryParams = "";

        const shareText = `Love this ${
            imageType === "icon" ? "icon" : "photo"
        } ${creatorName ? `by ${creatorName} ` : ``}from @NounProject.`;

        if (platform === "Twitter") {
            shareUrl = "https://twitter.com/intent/tweet";

            shareUrlQueryParams = {
                text: shareText,
                url: imagePermalink
            };
        } else if (platform === "Facebook") {
            shareUrl = "https://www.facebook.com/sharer/sharer.php";

            shareUrlQueryParams = {
                u: imagePermalink
            };
        }

        const shareUrlQueryParamsStringified = queryString.stringify(
            shareUrlQueryParams
        );

        return `${shareUrl}/?${shareUrlQueryParamsStringified}`;
    };

    const openWindowToShare = ({ shareUrl }) => {
        const width = 575;
        const height = 400;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;

        const windowOptions = `status=1,width=${width},height=${height},left=${left},top=${top}`;

        return window.open(shareUrl, "", windowOptions);
    };

    const handleClick = e => {
        e.preventDefault();

        const shareUrl = getShareUrl();
        openWindowToShare({ shareUrl });
    };

    return (
        <StyledSocialLink href="" onClick={handleClick}>
            {children}
        </StyledSocialLink>
    );
};

ShareImageToSocialMedia.propTypes = {
    platform: PropTypes.oneOf(["Twitter", "Facebook"]).isRequired,
    imageType: PropTypes.oneOf(["photo", "icon"]).isRequired,
    creatorName: PropTypes.string.isRequired,
    permalinkPath: PropTypes.string.isRequired
};

export default ShareImageToSocialMedia;
